import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link for navigation
import './CourseDetails.css'; 
import locationIcon from './../../assets/icons/ui/location.svg'
import LiveStatus from '../../components/ui/LiveStatus/LiveStatus';
import GradientButtonCourse from '../../components/ui/GradientButtonCourse/GradientButtonCourse';
import { useTranslation } from 'react-i18next';


interface CourseDetailsProps {
  title: string;
  description: string;
  dateRange: string;
  location:string;
  isPro: boolean;
  eventLink?: string; // ✅ New prop for event link
}

const CourseDetails: React.FC<CourseDetailsProps> = ({ title, description, dateRange, isPro, location, eventLink }) => {
  const { t } = useTranslation(); // ✅ Initialize translation
 return (
    <div className="course-details">
      {isPro && <span className="course-badge"> <img
          src={locationIcon}
          alt="location"
          className="location-icon" 
        />{location}</span>}
      <p className="course-date">{dateRange} <LiveStatus /> <span className="course-type"></span></p>
      
      <h2 className="course-title">  {title}</h2>
      <p className="course-description">{description}</p>
      
      {/* ✅ Add Link around the button */}
      {eventLink ? (
        <Link to={eventLink} style={{ textDecoration: 'none' }}>
          <GradientButtonCourse width="100%">{t("view_event")}</GradientButtonCourse>
        </Link>
      ) : (
        <GradientButtonCourse width="100%" disabled>{t("event_not_available")}</GradientButtonCourse>
      )}
    </div>
  );
};

export default CourseDetails;
